<template>
  <div>
    <group :title="$t('cart.address.address')">
      <div v-for="address in addressList">
        <AddressItem :address="address" @onAddressSelected="selectAddress(address)"></AddressItem> 
      </div>  
    </group>
  </div>
</template>
<script type="text/javascript">

import { mapGetters } from 'vuex'
import AddressItem from './AddressItem'
import { Group,Radio } from 'vux'

export default {
  name: 'AddressList',
  components: {
    AddressItem,
    Group,
    Radio
  },
  props: {
    addressList: Array
  },
  data() {
    return {

    }
  },
  created() {

  },
  mounted() {},
  watch: {},
  computed: {

  },
  methods: {
    selectAddress(address){
      console.log('selectAddress');
      this.$store.commit('updateCurrentAddress', address);
      this.$router.go(-1);
    }
  },
}

</script>
<style type="text/css">

</style>




// WEBPACK FOOTER //
// src/Cart/components/AddressList.vue